// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  release: '20250808-030112',
  production: false,
  appName: 'WebFormRenta210v18',
  urlIngreso: 'WebDilIngresoFormRenta210'
};


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/environments/environment.ts